const loginForm = document.getElementById("login-form-login-page");
const resetForm = document.querySelector(".js-reset-password");
const loginPageContent = document.querySelector(".js-customer-welcome");
const submittedForm = document.querySelector(".js-this-form-was-submitted");
const forgotPassButtons = document.querySelectorAll(".js-forgot-pass");
import { toggleShow } from "toggle-targets";
//
const hideLoginPageStuffAndShowRecoverPassword = () => {
  if (loginForm) loginForm.classList.add("active");
  if (resetForm) resetForm.removeAttribute("hidden");
  // if (loginPageContent) loginPageContent.style.display = "none";
};
if (window.location.hash == "#recover") {
  hideLoginPageStuffAndShowRecoverPassword();
}
// If clicking forgot password link on the /account/login page, reveal stuff as above
if (forgotPassButtons && window.location.pathname == "/account/login") {
  forgotPassButtons.forEach(r => {
    r.addEventListener("click", e => {
      e.preventDefault();
      hideLoginPageStuffAndShowRecoverPassword();
    });
  });
}
// If the login of reset password forms were submitted reveal the appropriate hidden toggle targets for client login
// Might not need a timeout, but JIC
setTimeout(() => {
  if (submittedForm) {
    const toggleSetWithinLoginPage = window.toggleSets.filter(
      t => t.id == "reset-set" || t.id == "login-form-set-login-page"
    );
    toggleSetWithinLoginPage.forEach(set => {
      set.targets.forEach(t => {
        toggleShow(t);
      });
    });
    // Also if it's within something that's hidden, such as js-reset-password, reveal that too
    if (submittedForm.closest("[hidden]")) {
      submittedForm.closest("[hidden]").removeAttribute("hidden");
    }
  }
}, 0);
